// ============================================================
// dtbase v2：material_lib 索引 Schema（规范 §6）
// ============================================================
import { z } from 'zod';

export const materialIndexSchema = z
  .object({
    schemaVersion: z.literal('2.0').default('2.0'),
    materials: z
      .array(
        z
          .object({
            id: z.string().min(1).max(128),
            files: z.record(z.string().max(300)),
            params: z.record(z.unknown()).optional(),
            hash: z.string().max(128).optional(),
            reusedBy: z.array(z.string().max(128)).max(500).optional(),
          })
          .strict(),
      )
      .max(1000)
      .default([]),
  })
  .strict();

export type MaterialIndex = z.infer<typeof materialIndexSchema>;
